<template>
    <div class="row">
        <div class="col-md-12">
            <!-- Nav -->
            <ul class="nav nav-tabs nav-overflow" :class="btnTabs?'btn-tabs':''">
                <li v-for="(tab, index) in tabs" :key="index" class="nav-item" :class="tab.hide? 'd-none':''">
                    <a
                        class="nav-link d-flex align-items-center gap-1"
                        v-if="showTab(tab.environmentRestrictions)"
                        :class="[activeTab == tab.name ? 'active':'', tab.hide? 'd-none':'']"
                        :id="'tab'+index"
                        data-bs-toggle="tab"
                        :data-bs-target="'#tab' + index + 'Content'"
                        type="button"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                        @click="tabClicked(tab)"
                        >
                        {{ tab.label || tab.name }}
                        <div v-if="tab.loading" class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div v-if="tab.tooltip" class="tab-help-wrapper">
                            <i class="fa fa-circle-info text-secondary"></i>
                            <div class="tab-help-popup">
                                <span>{{ tab.tooltip }}</span>
                                <span v-if="tab.helpLink" class="tab-help-link" @click.stop="openHelpLink(tab.helpLink.url)">{{ tab.helpLink.label }}</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li class="nav-item ms-auto p-2" :key="tabs.length">
                    <slot name="tab-action-buttons"></slot>
                </li>
            </ul>
        </div>
        <!-- <div class="col-md-2">
            <slot name="tab-action-buttons"></slot>
        </div> -->
    </div>
    <div class="row">
        <div class="col">
            <div class="tab-content" :class="btnTabs?'btn-tabs':''" id="tabContent">
                <div
                    v-for="(tab, index) in tabs"
                    :key="index"
                    class="tab-pane fade"
                    :class="[activeTab == tab.name ?'active show':'']"
                    :id="'tab' + index + 'Content'"
                    role="tabpanel"
                    :aria-labelledby="tab.id"
                >
                    <div v-if="tab.content">
                        <div v-html="tab.content"></div>
                    </div>
                    <div v-if="tab.iframe">
                        <iframe class="tab-frame" :src="tab.iframe"></iframe>
                    </div>
                    <div v-if="tab.slot">
                        <slot :name="tab.slot"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Tabs",
    props: {
        tabs: Object,
        btnTabs: {
            type: Boolean,
            default: false,
        }        
    },
    computed:{
        //active tab will be computed from store
        activeTab(){
            let activeTab=this.tabs[0].name
            //If we navigate to another menu that tab may not available so verify that
            let tabFind=this.tabs.find(tab=>tab.name==this.$store.state.activeTab); 
            if(this.$store.state.activeTab && tabFind)
                activeTab=this.$store.state.activeTab
            return activeTab
        }
    },    
    methods: {
        tabClicked(tab){
            this.$store.dispatch('setActiveTab',tab.name)
            if(tab.onClick){
               tab.onClick();
            }
        },
        showTab(value){
            if(value && value.indexOf(this.$store.state.environment) === -1)
                return false
            return true
        },
        openHelpLink(url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    }
};
</script>

<style scoped>
.tab-frame{
    width:100%;
    height:70vh;
}

.tab-help-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.tab-help-popup {
    display: none;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.12);
    padding: 8px 12px;
    min-width: 220px;
    max-width: 320px;
    font-size: 0.8rem;
    color: #495057;
    white-space: normal;
    z-index: 1060;
    line-height: 1.4;
}

.tab-help-popup::before {
    content: '';
    position: absolute;
    top: -8px;
    left: 0;
    right: 0;
    height: 8px;
}

.tab-help-link {
    display: block;
    margin-top: 6px;
    color: #0d6efd;
    text-decoration: underline;
    cursor: pointer;
}

.tab-help-wrapper:hover .tab-help-popup {
    display: block;
}

ul.nav-tabs {
    overflow: visible !important;
}

ul.nav-tabs .nav-item,
ul.nav-tabs .nav-link {
    overflow: visible;
}
</style>